var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.876 17.329",
    enableBackground: "new 0 0 21.876 17.329",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37B71C",
    d: "M7.368,10.829c0.096-0.135,0.175-0.288,0.291-0.404c3.152-3.163,6.306-6.323,9.462-9.48 c1.02-1.02,2.283-1.224,3.432-0.566c1.383,0.791,1.754,2.701,0.766,3.954c-0.111,0.141-0.228,0.278-0.355,0.405 c-3.886,3.895-7.771,7.79-11.662,11.679c-0.994,0.994-2.278,1.188-3.4,0.521c-0.235-0.139-0.45-0.322-0.645-0.516 c-1.452-1.441-2.903-2.884-4.342-4.338c-1.141-1.153-1.218-2.692-0.214-3.836c0.925-1.054,2.58-1.194,3.667-0.306 c0.182,0.148,0.353,0.31,0.519,0.476c0.765,0.76,1.527,1.523,2.291,2.284C7.197,10.721,7.223,10.733,7.368,10.829z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.d32982756934bd91311ef03ff0b83468.svg";
export { ForwardRef as ReactComponent };